import React from 'react';
import Link from '../../../../../elements/Link';
import Icon from '../../../../../elements/icons/Icon';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';
import { isParticipantsButtonVisible } from './isParticipantsButtonVisible';

function Participants(props) {
    const {event, session} = props,
        i18n = useI18n();

    if (!isParticipantsButtonVisible(event, session)) return null;

    return (
        <Link href="./participants">
            <Icon src="/img/users-group.png" size={34} />
            <br /> {i18n['label.participants']}
        </Link>
    );
}

export default Participants;
